module.exports = __webpack_public_path__ + "img/jinniao_icon01.c9ee6a84.png";